import { frontendURL } from '../../../../helper/URLHelper';
const Index = () => import('./Index.vue');
import SettingsWrapper from '../SettingsWrapper.vue';
import { VIP_PERMISSIONS } from 'dashboard/constants/permissions.js';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/vip'),
      meta: {
        permissions: ['administrator', VIP_PERMISSIONS],
      },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'vip_settings_index',
          component: Index,
          meta: {
            permissions: ['administrator', VIP_PERMISSIONS],
          },
        },
      ],
    },
  ],
};
